import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormFieldConfig } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';
import { PhoneNumberFormatService } from '../../services/phone-number-format.service';

@DwComponent({
  key: 'mobile-phone-form-control',
  name: 'Mobile Phone Form Control',
  componentType: DwComponentType.formControl,
  isGlobal: true,
})
@Component({
  selector: 'app-mobile-phone-form-control',
  templateUrl: './mobile-phone-form-control.component.html'
})
export class MobilePhoneFormControlComponent implements DwFormControl, OnInit, OnDestroy {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  inputClass = 'form-control';
  @Input() context: DwContext;

  private valueChangesSubscription: Subscription;

  constructor(private phoneNumberFormatService: PhoneNumberFormatService) { }

  ngOnInit(): void {
    this.applyFormattedValue(this.control?.value);

    this.valueChangesSubscription = this.control?.valueChanges.subscribe(value => {
      this.applyFormattedValue(value);
    });
  }

  ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formattedValue = this.phoneNumberFormatService.formatForInput(input.value);

    input.value = formattedValue;
    this.applyFormattedValue(formattedValue);
  }

  get control(): AbstractControl {
    return this.formGroup?.get(this.fieldDef?.attrName);
  }

  private applyFormattedValue(value: string): void {
    if (!this.control) {
      return;
    }

    const formattedValue = this.phoneNumberFormatService.formatForInput(value);

    if (this.control.value !== formattedValue) {
      this.control.setValue(formattedValue, { emitEvent: false });
    }
  }
}
